import { z } from "zod";

import { packagingSolutionProducedSchema } from "../packaging-solution";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

export const auditEventCompletedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Completed),
	data: packagingSolutionProducedSchema,
});

export type AuditEventCompleted = z.infer<typeof auditEventCompletedSchema>;
